<div class="widget-card pie-chart-kpi" [ngClass]="widthClass">
  <div class="widget-header">
    <div class="chart-title">
      <span class="title-text">{{ widgetTitle }}</span>
    </div>
    <gains-ellipsis-menu *ngIf="menuItems.length > 0" class="ellipsis-button" [menuItems]="menuItems" (changeEvent)="handleMenuAction($event)"> </gains-ellipsis-menu>
  </div>

  <div class="pie-chart-content">
    <div class="pie-charts-container" [ngClass]="'layout-' + layout">
      <!-- Current Value Pie Chart -->
      <gains-pie-svg class="current" [percentage]="currentValue.percentage" [label]="currentValue.label"> </gains-pie-svg>

      <!-- Target Value Pie Chart -->
      <gains-pie-svg class="target" [percentage]="targetValue.percentage" [label]="targetValue.label"> </gains-pie-svg>
    </div>
  </div>
</div>
